import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ListTicketAttributeComponent } from 'modules/ticket-attribute/list-ticket-attribute/list-ticket-attribute.component';
import { CreateTicketAttributeComponent } from 'modules/ticket-attribute/create-ticket-attribute/create-ticket-attribute.component';
import { SharedModule } from 'modules/shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    ListTicketAttributeComponent,
    CreateTicketAttributeComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    RouterModule.forChild([
      {
        path: 'list',
        component: ListTicketAttributeComponent,
        canActivate: [],
      },
      {
        path: 'create',
        component: CreateTicketAttributeComponent,
        canActivate: [],
      },
    ]),
  ],
  exports: [
    ListTicketAttributeComponent,
    CreateTicketAttributeComponent,
  ],
})
export class TicketAttributeModule { }
